import { useEffect } from "react";
import { focusRouteHeading, ROUTE_FOCUS_EVENT } from "./focus-management";

export function useRouteFocus() {
  useEffect(() => {
    let pendingFrame: number | undefined;

    const moveFocusToRouteHeading = () => {
      if (pendingFrame !== undefined) {
        window.cancelAnimationFrame(pendingFrame);
      }

      pendingFrame = window.requestAnimationFrame(() => {
        pendingFrame = undefined;
        focusRouteHeading();
      });
    };

    window.addEventListener("popstate", moveFocusToRouteHeading);
    window.addEventListener(ROUTE_FOCUS_EVENT, moveFocusToRouteHeading);

    return () => {
      if (pendingFrame !== undefined) {
        window.cancelAnimationFrame(pendingFrame);
      }
      window.removeEventListener("popstate", moveFocusToRouteHeading);
      window.removeEventListener(ROUTE_FOCUS_EVENT, moveFocusToRouteHeading);
    };
  }, []);
}
